import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import {
  ClassificationPropertyKeySchema,
  CriticalitySchema,
  LevelSchema,
  ScoreSchema,
} from "../classification/schemas";
import { api } from "./apiClient";
import { FORMS_API_BASE_ENDPOINT } from "./constants";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/classification-template`;

const keys = { all: () => ["classificationTemplate"] as const } as const;

const ClassificationTemplateResponseSchema = z.object({
  template: z.object({
    key: z.string(),
    description: z.string(),
    minLevel: LevelSchema,
    maxLevel: LevelSchema,
    properties: z.array(
      z.object({
        key: ClassificationPropertyKeySchema,
        label: z.string(),
        description: z.string(),
        question: z.string().optional(),
      })
    ),
    levels: z
      .array(
        z.object({
          level: LevelSchema,
          name: z.string(),
          title: z.string(),
          description: z.string(),
        })
      )
      .optional(),
  }),
  customerCustomizations: z.object({
    propertyDescriptions: z.array(
      z.object({
        propertyKey: ClassificationPropertyKeySchema,
        description: z.string(),
      })
    ),
  }),
  criticalityTable: z
    .array(
      z.object({
        scores: z.array(ScoreSchema),
        criticality: CriticalitySchema,
      })
    )
    .optional(),
});

export type ClassificationTemplate = z.infer<typeof ClassificationTemplateResponseSchema>["template"];
export type ClassificationCustomerCustomizations = z.infer<
  typeof ClassificationTemplateResponseSchema
>["customerCustomizations"];
export type ClassificationCriticalityTable = NonNullable<
  z.infer<typeof ClassificationTemplateResponseSchema>["criticalityTable"]
>;

export const classificationTemplateQueryOptions = () =>
  queryOptions({
    queryKey: keys.all(),
    queryFn: () => api.get(BASE_ENDPOINT, { schema: ClassificationTemplateResponseSchema }),
    throwOnError: true,
  });
